<template>
  <pt-deposit-settlement-table ref="table" :tableData="tableData" :totalNumber="totalNumber"  @getDepositSettlementList="getDepositSettlementList" v-loading="loading" class="pt-deposit-settlement-table__withData">
    <slot/>
  </pt-deposit-settlement-table>
</template>

<script>
import PtDepositSettlementTable from './index'
export default {
  name: 'pt-deposit-settlement-table__withData',
  components: {
    'pt-deposit-settlement-table': PtDepositSettlementTable
  },
  props: {
    pageSize: {
      type: Number,
      default: 10
    },
    paramsData: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      loading: false,
      totalNumber: 0,
      tableData: [],
      page: ''
    }
  },
  watch: {
    paramsData: {
      handler: function (val) {
        this.getDepositSettlementList(this.page)
      },
      deep: true
    }
  },
  methods: {
    getDepositSettlementList (page, next, size) {
      let data = {
        ...this.paramsData,
        pageable: {
          page: page,
          size: size || this.pageSize
        }
      }
      this.page = page
      if (!next) {
        this.loading = true
      }
      this.$store.dispatch('getDepositSettlementList', data).then(res => {
        this.tableData = res.data
        this.totalNumber = res.totalNumber
        if (next) {
          next(res.data)
        } else {
          this.loading = false
        }
      }).catch(err => {
        this.loading = false
        this.$message.error(err || '获取订金结算失败')
      })
    }
  }
}
</script>
